import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function IntelAxisTablePagination({
  currentPage,
  setCurrentPage,
  rowsPerPage,
  setRowsPerPage,
  totalRows,
  entityLabel = 'rows',
  pageInput,
  setPageInput,
  onPageInputSubmit,
  openFilter,
  setOpenFilter,
  filterKey = 'rows',
}) {
  const filterClickCount = useRef(0);
  const totalPages = Math.ceil(totalRows / rowsPerPage) || 0;

  return (
    <div className="pagination pagination-sticky">
      <div className="pg-info">
        Showing {totalRows === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1}–
        {Math.min(currentPage * rowsPerPage, totalRows)} of {totalRows} {entityLabel}
      </div>
      <div className="table-pagination">
        <div className="table-pagination__control">
          <span className="table-pagination__label">Rows per page</span>
          <div className={`select-wrap ${openFilter === filterKey ? 'is-open' : ''}`}>
            <span className="select-measure table-pagination__measure">{rowsPerPage}</span>
            <select
              className="filter-select table-pagination__select"
              value={rowsPerPage}
              onFocus={() => {
                filterClickCount.current = 0;
                setOpenFilter(filterKey);
              }}
              onBlur={() => {
                filterClickCount.current = 0;
                setOpenFilter(null);
              }}
              onClick={(e) => {
                filterClickCount.current += 1;
                if (filterClickCount.current > 1) e.target.blur();
              }}
              onChange={(e) => {
                setRowsPerPage(parseInt(e.target.value, 10));
                setCurrentPage(1);
                e.target.blur();
              }}
            >
              <option value={25} className="table-pagination__option">25</option>
              <option value={35} className="table-pagination__option">35</option>
              <option value={50} className="table-pagination__option">50</option>
            </select>
          </div>
        </div>
        <div className="pg-controls">
          <button
            type="button"
            className="pg-btn"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
          >
            <ChevronLeft size={14} />
          </button>
          <form onSubmit={onPageInputSubmit} className="companydetails-style-33">
            <input
              type="text"
              className="pg-input"
              value={pageInput}
              onChange={(e) => setPageInput(e.target.value)}
              onBlur={() => setPageInput(String(currentPage))}
            />
            <button type="submit" style={{ display: 'none' }} />
          </form>
          <button
            type="button"
            className="pg-btn"
            disabled={currentPage === totalPages || totalPages === 0}
            onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
          >
            <ChevronRight size={14} />
          </button>
        </div>
      </div>
    </div>
  );
}
